<template>
  <div class="order-detail-page">
    <div class="page-header">
      <span class="page-title">订单详情</span>
      <el-button type="primary" plain size="small" icon="el-icon-back" @click="returnFn()">返回列表</el-button>
    </div>
    <div class="descriptionsBox">
      <div v-if="userInfo && (userInfo.name || userInfo.tel)" class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">服务对象信息</span>
          <span v-if="orderInfo.order_status == '10'" class="status-tag">待服务</span>
          <span v-if="orderInfo.order_status == '30'" class="status-tag">服务中</span>
          <span v-if="orderInfo.order_status == '60'" class="status-tag">已完成</span>
        </div>
        <el-descriptions class="mt15" :column="3" :colon="false">
          <el-descriptions-item label="姓名">{{ userInfo.name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{ userInfo.sex || '-' }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ userInfo.tel || '-' }}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{ orderInfo.id_card }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ formatDateTime(userInfo.created_at) }}</el-descriptions-item>
          <el-descriptions-item label="地址">{{ userInfo.address || '-' }}</el-descriptions-item>
          <el-descriptions-item label="特殊困难老年人探访关爱服务记录表">
            <div>暂无记录</div>
          </el-descriptions-item>
          <el-descriptions-item v-if="orderPatientPhotos.length" label="服务对象照片">
            <div class="cert-imgs">
              <el-image
                v-for="(url, index) in orderPatientPhotos"
                :key="index"
                :src="url"
                :preview-src-list="orderPatientPhotos"
                class="cert-img"
                fit="cover"
              />
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">护工信息</span>
          <el-button v-if="canAssignCaregiver" type="primary" size="small" @click="openAssignDialog">指/改派护工</el-button>
        </div>
        <el-descriptions class="mt15" :column="5" :colon="false">
          <el-descriptions-item v-if="nurseList.length > 0" label="姓名">{{ primaryNurse.name }}{{ primaryNurse.id }}</el-descriptions-item>
          <el-descriptions-item v-if="nurseList.length > 0" label="手机号">{{ primaryNurse.tel }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">护理记录</span>
          <div class="info-card-head-right">
            <span class="month-count">本月服务次数 {{ rowData.currentMonthNum || '0' }}/4</span>
            <el-button type="primary" size="small" @click="openAddRecordDialog">添加护理记录</el-button>
          </div>
        </div>
        <el-table class="record-table" :data="records" style="width: 100%" :header-cell-style="{ background: '#fafafa', color: '#303133' }">
          <el-table-column minWidth="50" label="序号" align="center">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column minWidth="120" label="护士信息">
            <template slot-scope="{ row: { name, tel } }">
              <div class="nurse-cell">
                <div class="nurse-name">{{ name }}</div>
                <div class="nurse-tel">{{ tel }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column minWidth="140" label="开始时间">
            <template slot-scope="scope">
              <div>{{ formatRecordStart(scope.row) }}</div>
              <div>{{ formatRecordEnd(scope.row) }}</div>
            </template>
          </el-table-column>
          <el-table-column minWidth="220" label="服务项目">
            <template slot-scope="scope">
              <div v-if="recordVisitDisplayText(scope.row)" class="visit-record-inline">
                {{ recordVisitDisplayText(scope.row) }}
              </div>
              <template v-if="isRowHomeVisit(scope.row)">
                <div v-if="recordHomeVisitSceneUrls(scope.row).length" class="visit-media-block">
                  <div class="visit-media-label">探访照片</div>
                  <div class="imgbox service-item-imgs">
                    <el-image
                      v-for="(u, i) in recordHomeVisitSceneUrls(scope.row)"
                      :key="'scene-' + i"
                      class="litimg2"
                      :src="u"
                      :preview-src-list="recordHomeVisitSceneUrls(scope.row)"
                    />
                  </div>
                </div>
                <div
                  v-for="(sig, si) in recordHomeVisitSignatureEntries(scope.row)"
                  :key="'sig-' + si"
                  class="visit-media-block visit-signature-block"
                >
                  <div class="visit-media-label">{{ sig.label }}</div>
                  <div class="imgbox service-item-imgs">
                    <el-image
                      class="litimg2"
                      :src="sig.url"
                      :preview-src-list="[sig.url]"
                    />
                  </div>
                </div>
              </template>
              <div
                v-else-if="recordServiceLineItems(scope.row).length"
                class="service-items-block"
              >
                <div
                  v-for="(item, idx) in recordServiceLineItems(scope.row)"
                  :key="idx"
                  class="service-item-row"
                >
                  <div class="service-item-line">{{ item.name || '-' }} ￥{{ item.price != null ? item.price : '-' }}</div>
                  <div v-if="serviceItemImageUrls(item).length" class="imgbox service-item-imgs">
                    <el-image
                      v-for="(u, i) in serviceItemImageUrls(item)"
                      :key="i"
                      class="litimg2"
                      :src="u"
                      :preview-src-list="serviceItemImageUrls(item)"
                    />
                  </div>
                </div>
              </div>
              <span
                v-else-if="!recordVisitDisplayText(scope.row) && !isRowHomeVisit(scope.row) && !recordServiceLineItems(scope.row).length"
                class="empty-text">—</span>
            </template>
          </el-table-column>
          <el-table-column minWidth="140" label="本次服务内容">
            <template slot-scope="scope">
              <div>家庭成员人数 :{{ scope.row.person_num }}</div>
              <div>健康状况-表达能力 :{{ disabledCareMonthlyCap(1 ,scope.row.biaodanengli) }}</div>
              <div>健康状况-行动能力 :{{ disabledCareMonthlyCap(1 ,scope.row.xingdongnengli) }}</div>
              <div>健康状况-疾病状况 :{{ disabledCareMonthlyCap(2 ,scope.row.desease) }}</div>
              <div>精神状态-情绪状态 :{{ disabledCareMonthlyCap(1 ,scope.row.qingxuzhuangtai) }}</div>
            </template>
          </el-table-column>
          <el-table-column minWidth="140" label="本次服务内容">
            <template slot-scope="scope">
              <div>安全情况-燃气安全 :{{ disabledCareMonthlyCap(3 ,scope.row.ranqianquan)}}</div>
              <div>安全情况-水暖安全 :{{ disabledCareMonthlyCap(3 ,scope.row.shuinuananquan)}}</div>
              <div>安全情况-用电安全 :{{ disabledCareMonthlyCap(3 ,scope.row.yongdiananquan)}}</div>
              <div>卫生状况-个人卫生 :{{ disabledCareMonthlyCap(1 ,scope.row.gerenweisheng)}}</div>
              <div>卫生状况-家庭卫生 :{{ disabledCareMonthlyCap(1 ,scope.row.jiatingweisheng)}}</div>
              <div>居住环境-室内环境 :{{ disabledCareMonthlyCap(1 ,scope.row.shineihuanjing)}}</div>
            </template>
          </el-table-column>
          <el-table-column minWidth="140" label="本次服务内容">
            <template slot-scope="scope">
              <div>老年人服务需求 :{{ scope.row.service_need }}</div>
              <div>实施关爱服务建议 :{{ scope.row.service_sug }}</div>
              <div>关爱服务情况 :{{ scope.row.service_status }}</div>
              <div>卫老年人服务满意度评价 :{{ scope.row.service_eval }}</div>
            </template>
          </el-table-column>
          <el-table-column minWidth="100" label="操作" align="center">
            <template slot-scope="scope">
              <el-link
                v-if="disRoleArr.includes('5')"
                style="margin-right: 16px"
                type="primary"
                @click="openEditRecordDialog(scope.row)"
              >
                <i class="el-icon-edit"></i>
              </el-link>
              <el-link
                v-if="scope.$index === records.length - 1 && disRoleArr.includes('6')"
                type="danger"
                @click="handleDeleteRecord(scope.row.id)"
              >
                <i class="el-icon-delete"></i>
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      :title="editRecordIsCreate ? '添加服务记录' : '服务记录'"
      :visible.sync="editRecordVisible"
      width="700px"
      custom-class="service-record-edit-dialog"
      center
      destroy-on-close
      :close-on-click-modal="false"
      @closed="resetEditRecordForm"
    >
      <div class="service-record-edit-body">
        <el-form ref="editRecordForm" :model="editRecordForm" label-width="168px" label-position="left">
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="editRecordForm.startTime"
              type="datetime"
              placeholder="请选择开始时间"
              value-format="timestamp"
              format="yyyy-MM-dd HH:mm"
              class="w100"
            />
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              v-model="editRecordForm.endTime"
              type="datetime"
              placeholder="请选择结束时间"
              value-format="timestamp"
              format="yyyy-MM-dd HH:mm"
              class="w100"
            />
          </el-form-item>
          <el-form-item label="探访方式">
            <el-select
              v-model="editVisitRecord.visit_method"
              clearable
              placeholder="请选择探访方式"
              class="w100"
              @change="onVisitMethodChange"
            >
              <el-option label="电话问候" value="phone" />
              <el-option label="上门探访" value="home" />
              <el-option label="互联网音（视）频探访" value="internet" />
              <el-option label="其他" value="other" />
            </el-select>
            <el-input
              v-if="editVisitRecord.visit_method === 'other'"
              v-model="editVisitRecord.visit_method_remark"
              class="visit-method-remark"
              placeholder="请说明其他探访方式"
              maxlength="120"
            />
          </el-form-item>
          <el-form-item v-if="editVisitRecord.visit_method === 'phone'" label="电话是否接通">
            <el-radio-group v-model="editVisitRecord.call_connected">
              <el-radio :label="true">接通</el-radio>
              <el-radio :label="false">未接通</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="editVisitRecord.visit_method === 'home'" label="探访照片">
            <div class="edit-service-imgs visit-scene-imgs">
              <div v-for="(u, ui) in visitSceneImgUrls" :key="'scene-' + ui" class="edit-img-cell">
                <el-image class="edit-img-thumb" :src="u" fit="cover" :preview-src-list="visitSceneImgUrls" />
                <i class="el-icon-close edit-img-remove" title="移除" @click="removeVisitSceneImage(ui)" />
              </div>
              <el-upload
                v-if="visitSceneImgUrls.length < 3"
                class="edit-service-uploader"
                action="#"
                :show-file-list="false"
                :http-request="uploadVisitSceneImage"
              >
                <div class="edit-upload-placeholder">
                  <i class="el-icon-plus" />
                </div>
              </el-upload>
            </div>
            <p class="service-content-hint">可上传现场照片，最多 3 张</p>
          </el-form-item>

          <div class="visit-assess-block">
            <div class="visit-assess-title">家庭状况</div>
            <el-form-item label="家庭人口" class="visit-nested-form-item">
              <el-radio-group v-model="editVisitRecord.family_mode" class="visit-radio-stack">
                <el-radio label="none">无变化</el-radio>
                <el-radio label="increase">
                  增加
                  <el-input
                    v-model="editVisitRecord.family_increase_n"
                    :disabled="editVisitRecord.family_mode !== 'increase'"
                    class="visit-inline-num"
                    placeholder="人数"
                    maxlength="4"
                  />
                  人
                </el-radio>
                <el-radio label="decrease">
                  减少
                  <el-input
                    v-model="editVisitRecord.family_decrease_n"
                    :disabled="editVisitRecord.family_mode !== 'decrease'"
                    class="visit-inline-num"
                    placeholder="人数"
                    maxlength="4"
                  />
                  人
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="visit-assess-block">
            <div class="visit-assess-title">健康状况</div>
            <el-form-item label="表达能力">
              <el-radio-group v-model="editVisitRecord.health_mode" class="visit-radio-inline">
                <el-radio label="none">无变化</el-radio>
                <el-radio label="better">较好</el-radio>
                <el-radio label="worse">较差</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="行动能力">
              <el-radio-group v-model="editVisitRecord.mobility_mode" class="visit-radio-inline">
                <el-radio label="none">无变化</el-radio>
                <el-radio label="better">较好</el-radio>
                <el-radio label="worse">较差</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="疾病状况">
              <el-radio-group v-model="editVisitRecord.disease_mode" class="visit-radio-inline">
                <el-radio label="none">无变化</el-radio>
                <el-radio label="serious">严重</el-radio>
                <el-radio label="improving">转好</el-radio>
              </el-radio-group>
              <el-input
                v-model="editVisitRecord.disease_name"
                class="visit-disease-name"
                placeholder="疾病名称"
                maxlength="64"
              />
            </el-form-item>
          </div>

          <div class="visit-assess-block">
            <div class="visit-assess-title">精神状态</div>
            <el-form-item label="情绪状态">
              <el-radio-group v-model="editVisitRecord.emotion_mode" class="visit-radio-inline">
                <el-radio label="none">无变化</el-radio>
                <el-radio label="better">较好</el-radio>
                <el-radio label="worse">较差</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="visit-assess-block">
            <div class="visit-assess-title">安全情况</div>
            <el-form-item label="燃气安全">
              <el-select v-model="editVisitRecord.gas_safety" clearable placeholder="请选择" class="visit-safety-select">
                <el-option label="安全" value="safe" />
                <el-option label="较安全" value="relatively_safe" />
                <el-option label="不安全" value="unsafe" />
              </el-select>
            </el-form-item>
            <el-form-item label="水暖安全">
              <el-select v-model="editVisitRecord.water_safety" clearable placeholder="请选择" class="visit-safety-select">
                <el-option label="安全" value="safe" />
                <el-option label="较安全" value="relatively_safe" />
                <el-option label="不安全" value="unsafe" />
              </el-select>
            </el-form-item>
            <el-form-item label="用电安全">
              <el-select v-model="editVisitRecord.electricity_safety" clearable placeholder="请选择" class="visit-safety-select">
                <el-option label="安全" value="safe" />
                <el-option label="较安全" value="relatively_safe" />
                <el-option label="不安全" value="unsafe" />
              </el-select>
            </el-form-item>
          </div>

          <div class="visit-assess-block">
            <div class="visit-assess-title">卫生状况</div>
            <el-form-item label="个人卫生">
              <el-radio-group v-model="editVisitRecord.personal_hygiene_mode" class="visit-radio-inline">
                <el-radio label="none">无变化</el-radio>
                <el-radio label="better">较好</el-radio>
                <el-radio label="worse">较差</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="家庭卫生">
              <el-radio-group v-model="editVisitRecord.family_hygiene_mode" class="visit-radio-inline">
                <el-radio label="none">无变化</el-radio>
                <el-radio label="better">较好</el-radio>
                <el-radio label="worse">较差</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="visit-assess-block">
            <div class="visit-assess-title">居住环境</div>
            <el-form-item label="室内环境">
              <el-radio-group v-model="editVisitRecord.indoor_env_mode" class="visit-radio-inline">
                <el-radio label="none">无变化</el-radio>
                <el-radio label="better">较好</el-radio>
                <el-radio label="worse">较差</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <el-form-item label="老年人服务需求">
            <el-input v-model="editVisitRecord.elderly_needs" type="textarea" :rows="3" maxlength="2000" show-word-limit placeholder="请填写" />
          </el-form-item>
          <el-form-item label="实施关爱服务建议">
            <el-input v-model="editVisitRecord.care_suggestions" type="textarea" :rows="3" maxlength="2000" show-word-limit placeholder="请填写" />
          </el-form-item>
          <el-form-item label="关爱服务情况">
            <el-input v-model="editVisitRecord.care_situation" type="textarea" :rows="3" maxlength="2000" show-word-limit placeholder="请填写本次关爱服务情况" />
          </el-form-item>
          <el-form-item label="老年人服务满意度评价">
            <el-input v-model="editVisitRecord.satisfaction" type="textarea" :rows="3" maxlength="2000" show-word-limit placeholder="请填写" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer edit-record-footer">
        <el-button class="btn-cancel-outline" @click="editRecordVisible = false">取 消</el-button>
        <el-button type="primary" :loading="editRecordLoading" @click="submitEditRecord">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="指/改派护工" :visible.sync="assignVisible" width="600px" center destroy-on-close :close-on-click-modal="false">
      <el-form :model="assignForm" label-width="153px">
        <el-form-item label="护工">
          <el-select
            v-model="assignForm.nurse_id"
            allow-create
            filterable
            default-first-option
            clearable
            placeholder="请选择护工"
            class="w100"
          >
            <el-option
              v-for="n in nurseCandidates"
              :key="n.id"
              :label="`${n.name}/${n.tel}`"
              :value="n.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="assignVisible = false">取 消</el-button>
        <el-button type="primary" :loading="assignLoading" @click="submitAssign">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addTfRecord,
  allocateOrderInfoById,
  delDeleteDisRecord,
  editTfRecord,
  fetchNurseList,
  fetchOrdersTfDetail,
  uploadOssTfImg
} from '@/api'
import pictureCompress from 'picture-compressor'
import { formatDate } from 'element-ui/lib/utils/date-util'
import { getTfChildRoleIds, hasTfAssignNurse, isAdmin } from '@/utils/util'

export default {
  name: 'OrdersSnDetail',
  data() {
    return {
      orderId: '',
      editRecordVisible: false,
      /** true：新增记录（提交时不带 id）；false：编辑已有记录 */
      editRecordIsCreate: false,
      editRecordLoading: false,
      editRecordForm: {
        record_id: '',
        startTime: null,
        endTime: null
      },
      /** 探访关爱表单；提交时映射为 body：biaodanengli、tf_type、service_need 等（与 Apifox / NurseRecordsInfo 一致） */
      editVisitRecord: {
        visit_seq: '',
        visit_sheet_date: '',
        visit_method: '',
        visit_method_remark: '',
        call_connected: null,
        family_mode: 'none',
        family_increase_n: '',
        family_decrease_n: '',
        family_count: '',
        health_mode: 'none',
        mobility_mode: 'none',
        disease_mode: 'none',
        disease_name: '',
        emotion_mode: 'none',
        gas_safety: '',
        water_safety: '',
        electricity_safety: '',
        personal_hygiene_mode: 'none',
        family_hygiene_mode: 'none',
        indoor_env_mode: 'none',
        elderly_needs: '',
        care_suggestions: '',
        care_service_seq: '',
        care_service_date: '',
        care_situation: '',
        signature_staff_url: '',
        signature_staff_date: '',
        satisfaction: '',
        signature_visitor_url: '',
        signature_visited_url: '',
        signature_data_entry_url: '',
        visit_sign_date: ''
      },
      visitSceneImgUrls: [],
      rowData: {
        orderInfo: {},
        userInfo: {},
        nurseInfo: {},
        nurseRecordsInfo: []
      },
      assignVisible: false,
      assignLoading: false,
      assignForm: {
        nurse_id: ''
      },
      nurseCandidates: []
    }
  },
  computed: {
    disRoleArr() {
      return getTfChildRoleIds(this.$store.state.rules)
    },
    orderInfo() {
      return this.rowData.orderInfo || {}
    },
    userInfo() {
      return this.rowData.userInfo || {}
    },
    records() {
      return this.rowData.nurseRecordsInfo || []
    },
    nurseList() {
      return this.normalizeNurseInfo(this.rowData.nurseInfo)
    },
    primaryNurse() {
      return this.nurseList[0] || {}
    },
    /** 当前订单已指派护工 id（用于新增护理记录 body.nurse_id） */
    primaryNurseId() {
      const n = this.primaryNurse
      if (!n || typeof n !== 'object') return ''
      const v =
        n.nurse_id != null && n.nurse_id !== ''
          ? n.nurse_id
          : n.id != null && n.id !== ''
            ? n.id
            : n.user_id != null && n.user_id !== ''
              ? n.user_id
              : ''
      return v !== '' && v !== undefined ? String(v) : ''
    },
    orderPatientPhotos() {
      const urls = this.orderInfo.img_urls
      if (!urls) return []
      if (Array.isArray(urls)) return urls.filter(Boolean)
      return String(urls)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    },
    canAssignCaregiver() {
      // 探访关爱「指派订单」不一定是 7，与寄宿托养一样：有菜单或子权限 1/7/8 即显示
      return isAdmin()
        || this.disRoleArr.includes('1')
        || this.disRoleArr.includes('7')
        || this.disRoleArr.includes('8')
        || hasTfAssignNurse(this.$store.state.rules)
    }
  },
  mounted() {
    this.orderId = this.$route.query.id || ''
    this.getDetail()
  },
  methods: {
    returnFn() {
      this.$router.push('/orders_tf')
    },
    formatDateTime(v) {
      if (v == null || v === '' || v === 0) return '-'
      const n = Number(v)
      const ms = n < 1e12 ? n * 1000 : n
      return formatDate(ms, 'yyyy-MM-dd HH:mm:ss')
    },
    /** 失能护理单月封顶：失能 150 元 / 半失能 100 元 */
    disabledCareMonthlyCap (_Type, _Num) {
      if (_Type === 1) return Number(_Num) === 0 ? '无变化' : (Number(_Num) === 1 ? '较好' : '较差')
      if (_Type === 2) return Number(_Num) === 0 ? '无变化' : (Number(_Num) === 1 ? '严重' : '较好')
      if (_Type === 3) return Number(_Num) === 0 ? '安全' : (Number(_Num) === 1 ? '较安全' : '不安全')
    },
    tsToMs(ts) {
      if (ts == null || ts === '') return null
      const n = Number(ts)
      return n < 1e12 ? n * 1000 : n
    },
    /** 护理记录归属自然月 yyyy-MM，与列表汇总一致：优先 dis_start_at，否则 service_at */
    recordMonthKey(row) {
      if (!row) return ''
      const raw = row.dis_start_at != null && row.dis_start_at !== '' ? row.dis_start_at : row.service_at != null && row.service_at !== '' ? row.service_at : null
      if (raw === null || raw === '') return ''
      const ms = this.tsToMs(raw)
      if (ms == null) return ''
      return formatDate(ms, 'yyyy-MM')
    },

    formatRecordStart(row) {
      if (row.dis_start_at != null && row.dis_start_at !== '') {
        const ms = this.tsToMs(row.dis_start_at)
        return ms != null ? formatDate(ms, 'yyyy-MM-dd HH:mm') : '-'
      }
      if (row.service_at != null && row.service_at !== '') {
        const ms = this.tsToMs(row.service_at)
        return ms != null ? formatDate(ms, 'yyyy-MM-dd HH:mm') : '-'
      }
      return '-'
    },
    formatRecordEnd(row) {
      if (row.dis_end_at != null && row.dis_end_at !== '') {
        const ms = this.tsToMs(row.dis_end_at)
        return ms != null ? formatDate(ms, 'yyyy-MM-dd HH:mm') : '-'
      }
      if (row.end_at != null && row.end_at !== '') {
        const ms = this.tsToMs(row.end_at)
        return ms != null ? formatDate(ms, 'yyyy-MM-dd HH:mm') : '-'
      }
      return '-'
    },
    /** 列表「服务项目」列：优先旧版 service_json.visit_record，否则用扁平字段 tf_type / is_connect */
    recordVisitDisplayText(row) {
      if (!row) return ''
      const items = this.recordServiceLineItems(row)
      const it = items[0]
      if (it && it.visit_record != null && it.visit_record !== '') {
        let vr = it.visit_record
        if (typeof vr === 'string') {
          try {
            vr = JSON.parse(vr)
          } catch (e) {
            vr = null
          }
        }
        if (vr && typeof vr === 'object') {
          const parts = []
          if (vr.visit_method === 'phone') parts.push('电话问候')
          else if (vr.visit_method === 'home') parts.push('上门探访')
          else if (vr.visit_method === 'internet') parts.push('互联网音视频探访')
          else if (vr.visit_method === 'other') parts.push('其他探访')
          if (vr.visit_method === 'phone' && vr.call_connected === true) parts.push('已接通')
          if (vr.visit_method === 'phone' && vr.call_connected === false) parts.push('未接通')
          if (parts.length) return parts.join(' · ')
        }
      }
      const tf = row.tf_type != null && row.tf_type !== '' ? Number(row.tf_type) : NaN
      if (tf === 1) return '上门探访'
      if (tf === 2) {
        const parts = ['电话问候']
        const ic = Number(row.is_connect)
        if (ic === 1) parts.push('已接通')
        else if (ic === 0) parts.push('未接通')
        return parts.join(' · ')
      }
      return ''
    },
    /** 是否为上门探访（tf_type=1 或旧版 service_json.visit_record.visit_method=home） */
    isRowHomeVisit(row) {
      if (!row) return false
      if (Number(row.tf_type) === 1) return true
      const raw = this.parseJsonArrayField(row.service_json) || this.parseJsonArrayField(row.services_json)
      if (!raw || !raw[0]) return false
      let vr = raw[0].visit_record
      if (vr == null || vr === '') return false
      if (typeof vr === 'string' && vr.trim()) {
        try {
          vr = JSON.parse(vr)
        } catch (e) {
          return false
        }
      }
      return !!(vr && typeof vr === 'object' && vr.visit_method === 'home')
    },
    /** 护理记录顶层探访照片 img_urls（数组或逗号分隔字符串） */
    parseRecordRowImgUrls(row) {
      if (!row || row.img_urls == null || row.img_urls === '') return []
      if (Array.isArray(row.img_urls)) return row.img_urls.filter(Boolean)
      return String(row.img_urls)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    },
    /** 上门探访现场图：优先记录顶层 img_urls；兼容旧数据 service_json / visit_record.scene_img_urls */
    recordHomeVisitSceneUrls(row) {
      if (!row || !this.isRowHomeVisit(row)) return []
      const top = this.parseRecordRowImgUrls(row)
      if (top.length) return top
      const raw = this.parseJsonArrayField(row.service_json) || this.parseJsonArrayField(row.services_json)
      if (!raw || !raw.length) return []
      const first = raw[0]
      const fromItem = this.serviceItemImageUrls(first)
      if (fromItem.length) return fromItem
      let vr = first.visit_record
      if (typeof vr === 'string' && vr.trim()) {
        try {
          vr = JSON.parse(vr)
        } catch (e) {
          vr = null
        }
      }
      if (vr && Array.isArray(vr.scene_img_urls) && vr.scene_img_urls.length) {
        return vr.scene_img_urls.filter(Boolean)
      }
      return []
    },
    /** 上门签字：service_img 探访人员签字、service_person_img 被探访人签字（支持逗号多图） */
    recordHomeVisitSignatureEntries(row) {
      if (!row || !this.isRowHomeVisit(row)) return []
      const out = []
      const pushUrls = (label, val) => {
        if (val == null || String(val).trim() === '') return
        const urls = String(val)
          .split(',')
          .map(s => s.trim())
          .filter(Boolean)
        urls.forEach((url, idx) => {
          out.push({ label: urls.length > 1 ? `${label} ${idx + 1}` : label, url })
        })
      }
      pushUrls('探访人员签字', row.service_img)
      pushUrls('被探访人员签字', row.service_person_img)
      return out
    },
    normalizeNurseInfo(raw) {
      if (raw == null) return []
      if (Array.isArray(raw)) return raw.filter(Boolean)
      if (typeof raw === 'object') {
        const keys = Object.keys(raw).filter(k => /^\d+$/.test(String(k)))
        keys.sort((a, b) => Number(a) - Number(b))
        return keys.map(k => raw[k]).filter(item => item && typeof item === 'object')
      }
      return []
    },
    /** 将详情里可能是字符串的 JSON 数组解析为数组 */
    parseJsonArrayField(val) {
      if (val == null) return null
      if (Array.isArray(val)) return val
      if (typeof val === 'string') {
        const t = val.trim()
        if (!t) return null
        try {
          const p = JSON.parse(t)
          return Array.isArray(p) ? p : null
        } catch (e) {
          return null
        }
      }
      return null
    },
    pickServiceItemId(it) {
      if (!it || typeof it !== 'object') return ''
      const v =
        it.id != null && it.id !== ''
          ? it.id
          : it.item_id != null && it.item_id !== ''
            ? it.item_id
            : it.service_id != null && it.service_id !== ''
              ? it.service_id
              : ''
      return v === '' || v === undefined ? '' : String(v)
    },
    serviceRecordItems(row) {
      if (!row) return []
      const raw = this.parseJsonArrayField(row.service_json) || this.parseJsonArrayField(row.services_json)
      if (!raw || !raw.length) {
        const hasTf = row.tf_type !== undefined && row.tf_type !== null && row.tf_type !== ''
        // 仅上门且无 service_json 时用占位行；电话探访只展示摘要，避免重复一行
        if (hasTf && Number(row.tf_type) === 1) {
          return [
            {
              id: 'tf',
              name: row.service_name || '探访关爱',
              price: row.services_total != null ? row.services_total : '',
              visit_record: ''
            }
          ]
        }
        const si = row.service_item
        if (si != null && String(si).trim() !== '') {
          return String(si)
            .split(',')
            .map(x => x.trim())
            .filter(Boolean)
            .map(id => ({ id, name: '', price: '' }))
        }
        return []
      }
      const filtered = raw.filter(
        s =>
          s &&
          (s.name ||
            s.price != null ||
            this.pickServiceItemId(s) ||
            (s.visit_record != null && s.visit_record !== ''))
      )
      if (filtered.length) return filtered
      const hasTfAfterFilter =
        row.tf_type !== undefined && row.tf_type !== null && row.tf_type !== ''
      if (hasTfAfterFilter && Number(row.tf_type) === 1) {
        return [
          {
            id: 'tf',
            name: row.service_name || '探访关爱',
            price: row.services_total != null ? row.services_total : '',
            visit_record: ''
          }
        ]
      }
      return []
    },
    legacyServiceLines(row) {
      if (!row.services || !row.services.length) return []
      return row.services
    },
    /** 当前行展示用的服务项目列表（优先 service_json，否则旧版 services） */
    recordServiceLineItems(row) {
      const items = this.serviceRecordItems(row)
      if (items.length) return items
      return this.legacyServiceLines(row)
    },
    /** 单个服务项目下的图片 URL 列表 */
    serviceItemImageUrls(s) {
      if (!s) return []
      if (Array.isArray(s.img_urls)) return s.img_urls.filter(Boolean)
      if (s.img_urls != null && s.img_urls !== '') {
        if (typeof s.img_urls === 'string') {
          return s.img_urls
            .split(',')
            .map(x => x.trim())
            .filter(Boolean)
        }
      }
      if (Array.isArray(s.imgs_url)) return s.imgs_url.filter(Boolean)
      if (s.imgs_url != null && s.imgs_url !== '' && typeof s.imgs_url === 'string') {
        return s.imgs_url
          .split(',')
          .map(x => x.trim())
          .filter(Boolean)
      }
      if (s.img_url != null && s.img_url !== '') {
        const u = String(s.img_url).trim()
        return u ? [u] : []
      }
      if (Array.isArray(s.imgs)) return s.imgs.filter(Boolean)
      return []
    },
    getDetail() {
      if (!this.orderId) {
        this.$message.warning('缺少订单参数')
        return
      }
      fetchOrdersTfDetail({ order_id: this.orderId }).then(res => {
        if (res.status && res.data) {
          this.rowData = {
            orderInfo: res.data.orderInfo || {},
            userInfo: res.data.userInfo || {},
            nurseInfo: res.data.nurseInfo != null ? res.data.nurseInfo : {},
            nurseRecordsInfo: res.data.nurseRecordsInfo || [],
            currentMonthNum: res.data.currentMonthNum || '',
            currentMonthPrice: res.data.currentMonthPrice || ''
          }
        } else {
          this.$message.warning(res.msg || '加载失败')
        }
      })
    },
    /** 与订单详情 ChangeOrderNurseInfo 一致：/manage/nurses/index 不传参，data 为护工数组 */
    async getNurseList() {
      const { status, data } = await fetchNurseList()
      if (status && data != null) {
        this.nurseCandidates = Array.isArray(data) ? data : data.list || []
      } else {
        this.nurseCandidates = []
      }
    },
    async openAssignDialog() {
      await this.getNurseList()
      this.assignForm = { nurse_id: '' }
      this.assignVisible = true
    },
    submitAssign() {
      if (!this.assignForm.nurse_id) {
        this.$message.warning('请选择护工')
        return
      }
      this.assignLoading = true
      allocateOrderInfoById({
        order_id: this.orderId,
        nurse_id: this.assignForm.nurse_id
      })
        .then(res => {
          if (res.status) {
            this.$message.success(res.msg || '操作成功')
            this.assignVisible = false
            this.getDetail()
          } else {
            this.$message.warning(res.msg || '操作失败')
          }
        })
        .finally(() => {
          this.assignLoading = false
        })
    },
    handleDeleteRecord(record_id) {
      this.$confirm('确定删除护理纪录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delDeleteDisRecord({ record_id }).then(res => {
            if (res.status) {
              this.$message.success(res.msg || '删除成功!')
              this.getDetail()
            } else {
              this.$message.warning(res.msg || '删除失败')
            }
          })
        })
        .catch(() => {})
    },
    defaultEditVisitRecord() {
      return {
        visit_seq: '',
        visit_sheet_date: '',
        visit_method: '',
        visit_method_remark: '',
        call_connected: null,
        family_mode: 'none',
        family_increase_n: '',
        family_decrease_n: '',
        family_count: '',
        health_mode: 'none',
        mobility_mode: 'none',
        disease_mode: 'none',
        disease_name: '',
        emotion_mode: 'none',
        gas_safety: '',
        water_safety: '',
        electricity_safety: '',
        personal_hygiene_mode: 'none',
        family_hygiene_mode: 'none',
        indoor_env_mode: 'none',
        elderly_needs: '',
        care_suggestions: '',
        care_service_seq: '',
        care_service_date: '',
        care_situation: '',
        signature_staff_url: '',
        signature_staff_date: '',
        satisfaction: '',
        signature_visitor_url: '',
        signature_visited_url: '',
        signature_data_entry_url: '',
        visit_sign_date: ''
      }
    },
    /** 探访方式 → tf_type：1 上门，2 电话（互联网/其他按上门提交） */
    visitMethodToTfType(method) {
      if (method === 'phone') return 2
      return 1
    },
    /** 关爱服务情况：互联网/其他探访写入前缀，便于与仅支持 tf_type 1/2 的后端对齐 */
    mergeServiceStatusRemark(ev) {
      let text = ev.care_situation != null ? String(ev.care_situation) : ''
      if (ev.visit_method === 'internet') {
        text = `[互联网音（视）频探访]\n${text}`
      }
      if (ev.visit_method === 'other' && ev.visit_method_remark) {
        text = `[其他探访：${ev.visit_method_remark}]\n${text}`
      }
      return text.trim()
    },
    numToTriMode(n) {
      const v = Number(n)
      if (v === 1) return 'better'
      if (v === 2) return 'worse'
      return 'none'
    },
    numToDiseaseMode(n) {
      const v = Number(n)
      if (v === 1) return 'serious'
      if (v === 2) return 'improving'
      return 'none'
    },
    safetyNumToStr(n) {
      const v = Number(n)
      if (v === 1) return 'relatively_safe'
      if (v === 2) return 'unsafe'
      return 'safe'
    },
    decodePersonNum(s) {
      const t = String(s == null ? '' : s).trim()
      if (t.startsWith('+')) {
        const n = t.slice(1) || '1'
        return { family_mode: 'increase', family_increase_n: n, family_decrease_n: '' }
      }
      if (t.startsWith('-')) {
        const n = t.slice(1) || '1'
        return { family_mode: 'decrease', family_increase_n: '', family_decrease_n: n }
      }
      return { family_mode: 'none', family_increase_n: '', family_decrease_n: '' }
    },
    triModeToApiNum(mode) {
      if (mode === 'better') return 1
      if (mode === 'worse') return 2
      return 0
    },
    diseaseModeToApiNum(mode) {
      if (mode === 'serious') return 1
      if (mode === 'improving') return 2
      return 0
    },
    safetyStrToApiNum(s) {
      if (s === 'relatively_safe') return 1
      if (s === 'unsafe') return 2
      return 0
    },
    encodePersonNumFromVisit(ev) {
      if (ev.family_mode === 'increase') {
        const n = parseInt(String(ev.family_increase_n).trim(), 10)
        return Number.isFinite(n) && n > 0 ? `+${n}` : '+1'
      }
      if (ev.family_mode === 'decrease') {
        const n = parseInt(String(ev.family_decrease_n).trim(), 10)
        return Number.isFinite(n) && n > 0 ? `-${n}` : '-1'
      }
      return '0'
    },
    /** 从 NurseRecordsInfo 扁平字段回填表单（与 Apifox body 一致） */
    hydrateVisitFormFromTfRow(row) {
      if (!row || typeof row !== 'object') return
      if (row.tf_type !== undefined && row.tf_type !== null && row.tf_type !== '') {
        const tfn = Number(row.tf_type)
        if (tfn === 1) this.editVisitRecord.visit_method = 'home'
        else if (tfn === 2) this.editVisitRecord.visit_method = 'phone'
      }
      const ic = row.is_connect
      if (ic === 1 || ic === '1') this.editVisitRecord.call_connected = true
      else if (ic === 0 || ic === '0') this.editVisitRecord.call_connected = false
      else this.editVisitRecord.call_connected = null

      const pn = this.decodePersonNum(row.person_num)
      this.editVisitRecord.family_mode = pn.family_mode
      this.editVisitRecord.family_increase_n = pn.family_increase_n
      this.editVisitRecord.family_decrease_n = pn.family_decrease_n

      this.editVisitRecord.health_mode = this.numToTriMode(row.biaodanengli)
      this.editVisitRecord.mobility_mode = this.numToTriMode(row.xingdongnengli)
      this.editVisitRecord.disease_mode = this.numToDiseaseMode(row.desease)
      this.editVisitRecord.disease_name = row.desease_name != null ? String(row.desease_name) : ''
      this.editVisitRecord.emotion_mode = this.numToTriMode(row.qingxuzhuangtai)
      this.editVisitRecord.gas_safety = this.safetyNumToStr(row.ranqianquan)
      this.editVisitRecord.water_safety = this.safetyNumToStr(row.shuinuananquan)
      this.editVisitRecord.electricity_safety = this.safetyNumToStr(row.yongdiananquan)
      this.editVisitRecord.personal_hygiene_mode = this.numToTriMode(row.gerenweisheng)
      this.editVisitRecord.family_hygiene_mode = this.numToTriMode(row.jiatingweisheng)
      this.editVisitRecord.indoor_env_mode = this.numToTriMode(row.shineihuanjing)
      this.editVisitRecord.elderly_needs = row.service_need != null ? String(row.service_need) : ''
      this.editVisitRecord.care_suggestions = row.service_sug != null ? String(row.service_sug) : ''
      this.editVisitRecord.care_situation = row.service_status != null ? String(row.service_status) : ''
      this.editVisitRecord.satisfaction = row.service_eval != null ? String(row.service_eval) : ''
      this.editVisitRecord.signature_visitor_url = row.service_img != null ? String(row.service_img) : ''
      this.editVisitRecord.signature_visited_url =
        row.service_person_img != null ? String(row.service_person_img) : ''
    },
    /** 从当前行解析探访表单：兼容旧 service_json[0].visit_record，否则走扁平 NurseRecordsInfo */
    applyVisitRecordFromRow(row) {
      this.editVisitRecord = { ...this.defaultEditVisitRecord() }
      this.visitSceneImgUrls = []
      const items = this.serviceRecordItems(row).length ? this.serviceRecordItems(row) : this.legacyServiceLines(row)
      const first = items[0]
      let parsedVr = null
      let usedVisitJson = false
      if (first && typeof first === 'object') {
        let vr = first.visit_record
        if (typeof vr === 'string' && vr.trim()) {
          try {
            vr = JSON.parse(vr)
          } catch (e) {
            vr = null
          }
        }
        if (vr && typeof vr === 'object' && (vr.visit_method || vr.visit_sheet_date || vr.family_mode)) {
          usedVisitJson = true
          parsedVr = vr
          const base = this.defaultEditVisitRecord()
          Object.keys(base).forEach(k => {
            if (vr[k] !== undefined && vr[k] !== null) this.editVisitRecord[k] = vr[k]
          })
        }
      }
      if (!usedVisitJson) {
        this.hydrateVisitFormFromTfRow(row || {})
      }
      if (this.editVisitRecord.visit_method === 'home') {
        const fromRowTop = this.parseRecordRowImgUrls(row || {})
        if (fromRowTop.length) {
          this.visitSceneImgUrls = [...fromRowTop]
        } else if (first && typeof first === 'object') {
          const sceneFromVr =
            parsedVr && Array.isArray(parsedVr.scene_img_urls) && parsedVr.scene_img_urls.length
              ? parsedVr.scene_img_urls.filter(Boolean)
              : []
          const scene = sceneFromVr.length ? sceneFromVr : this.serviceItemImageUrls(first)
          if (scene.length) this.visitSceneImgUrls = [...scene]
        }
      }
    },
    removeVisitSceneImage(ui) {
      this.visitSceneImgUrls.splice(ui, 1)
    },
    uploadVisitSceneImage(options) {
      const item = options
      const reader = new FileReader()
      reader.readAsDataURL(item.file)
      reader.onload = () => {
        pictureCompress({
          img: reader.result,
          width: 500,
          height: 500
        })
          .then(res => {
            return uploadOssTfImg({
              data: res.img,
              dir: this.orderInfo.id_card,
              dir2: 'service',
              fileName: item.file.uid
            })
          })
          .then(resp => {
            if (resp.status && resp.data && resp.data.url) {
              if (this.visitSceneImgUrls.length >= 3) {
                this.$message.warning('现场照片最多 3 张')
                return
              }
              this.visitSceneImgUrls.push(resp.data.url)
            } else {
              this.$message.warning((resp && resp.msg) || '图片上传失败')
            }
          })
          .catch(() => {})
      }
    },
    onVisitMethodChange(v) {
      if (v !== 'phone') {
        this.editVisitRecord.call_connected = null
      }
      if (v !== 'home') {
        this.visitSceneImgUrls = []
        this.editVisitRecord.signature_visited_url = ''
      }
      if (v !== 'other') {
        this.editVisitRecord.visit_method_remark = ''
      }
    },
    async openAddRecordDialog() {
      if (!this.orderId) {
        this.$message.warning('缺少订单参数')
        return
      }
      const n = Number(this.rowData.currentMonthNum)
      if (Number.isFinite(n) && n >= 4) {
        this.$message.warning('本月服务次数已达上限 4 次')
        return
      }
      this.editRecordIsCreate = true
      this.editRecordForm = {
        record_id: '',
        startTime: null,
        endTime: null
      }
      this.applyVisitRecordFromRow({})
      this.editRecordVisible = true
    },
    async openEditRecordDialog(row) {
      if (!row || row.id == null) {
        this.$message.warning('记录数据异常')
        return
      }
      this.editRecordIsCreate = false
      const startKey =
        row.dis_start_at != null && row.dis_start_at !== '' ? 'dis_start_at' : 'service_at'
      const endKey = row.dis_end_at != null && row.dis_end_at !== '' ? 'dis_end_at' : 'end_at'
      const startMs = this.tsToMs(row[startKey])
      const endMs = this.tsToMs(row[endKey])
      this.editRecordForm = {
        record_id: row.id,
        startTime: startMs != null ? startMs : null,
        endTime: endMs != null ? endMs : null
      }
      this.applyVisitRecordFromRow(row)
      this.editRecordVisible = true
    },
    resetEditRecordForm() {
      this.editRecordIsCreate = false
      this.editRecordForm = {
        record_id: '',
        startTime: null,
        endTime: null
      }
      this.editVisitRecord = { ...this.defaultEditVisitRecord() }
      this.visitSceneImgUrls = []
    },
    /** 探访照片提交：多图逗号拼接，写入 body.img_urls（与记录顶层字段一致） */
    joinServiceItemImgUrls(urls) {
      const list = (urls || []).filter(Boolean)
      return list.length ? list.join(',') : ''
    },
    /**
     * 构建探访记录提交体（与 Apifox 一致；axios 拦截器会包成 { head, body }）
     * 字段含义同 NurseRecordsInfo：biaodanengli 表达能力 0/1/2，ranqianquan 燃气安全 0/1/2，等
     */
    buildTfRecordSubmitBody(disStart, disEnd, recordId, isCreate) {
      const ev = this.editVisitRecord
      const tfType = this.visitMethodToTfType(ev.visit_method)
      const oid = Number(this.orderId)
      const orderIdStr = String(Number.isFinite(oid) ? oid : this.orderId)
      const sceneJoined =
        ev.visit_method === 'home' ? this.joinServiceItemImgUrls(this.visitSceneImgUrls) : ''
      const body = {
        order_id: orderIdStr,
        dis_start_at: String(disStart),
        dis_end_at: String(disEnd),
        tf_type: String(tfType),
        is_connect:
          tfType === 2
            ? ev.call_connected === true
              ? '1'
              : ev.call_connected === false
                ? '0'
                : ''
            : '',
        person_num: this.encodePersonNumFromVisit(ev),
        biaodanengli: String(this.triModeToApiNum(ev.health_mode)),
        xingdongnengli: String(this.triModeToApiNum(ev.mobility_mode)),
        desease: String(this.diseaseModeToApiNum(ev.disease_mode)),
        desease_name: ev.disease_name != null ? String(ev.disease_name) : '',
        qingxuzhuangtai: String(this.triModeToApiNum(ev.emotion_mode)),
        ranqianquan: String(this.safetyStrToApiNum(ev.gas_safety)),
        shuinuananquan: String(this.safetyStrToApiNum(ev.water_safety)),
        yongdiananquan: String(this.safetyStrToApiNum(ev.electricity_safety)),
        gerenweisheng: String(this.triModeToApiNum(ev.personal_hygiene_mode)),
        jiatingweisheng: String(this.triModeToApiNum(ev.family_hygiene_mode)),
        shineihuanjing: String(this.triModeToApiNum(ev.indoor_env_mode)),
        service_need: ev.elderly_needs != null ? String(ev.elderly_needs) : '',
        service_sug: ev.care_suggestions != null ? String(ev.care_suggestions) : '',
        service_status: this.mergeServiceStatusRemark(ev),
        service_eval: ev.satisfaction != null ? String(ev.satisfaction) : '',
        service_img: ev.signature_visitor_url != null ? String(ev.signature_visitor_url) : '',
        service_person_img:
          ev.visit_method === 'home' && ev.signature_visited_url != null ? String(ev.signature_visited_url) : ''
      }
      if (recordId != null && recordId !== '') {
        body.id = String(recordId)
      }
      if (ev.visit_method === 'home' && sceneJoined) {
        body.img_urls = sceneJoined
      }
      if (isCreate) {
        const nid = this.primaryNurseId
        if (nid) body.nurse_id = nid
      }
      return body
    },
    submitEditRecord() {
      const { record_id, startTime, endTime } = this.editRecordForm
      if (!this.editRecordIsCreate && !record_id) {
        this.$message.warning('缺少记录 ID')
        return
      }
      if (!this.editVisitRecord.visit_method) {
        this.$message.warning('请选择探访方式')
        return
      }
      if (this.editVisitRecord.visit_method === 'phone') {
        if (this.editVisitRecord.call_connected !== true && this.editVisitRecord.call_connected !== false) {
          this.$message.warning('请选择电话是否接通')
          return
        }
      }
      const toUnixSec = ts => {
        if (ts == null || ts === '') return 0
        const n = Number(ts)
        return Math.floor(n / 1000)
      }
      const disStart = toUnixSec(startTime)
      const disEnd = toUnixSec(endTime)
      if (!disStart || !disEnd) {
        this.$message.warning('请选择开始时间与结束时间')
        return
      }
      if (disEnd <= disStart) {
        this.$message.warning('结束时间须晚于开始时间')
        return
      }
      if (this.editRecordIsCreate && !this.primaryNurseId) {
        this.$message.warning('请先为该订单指派护工后再添加护理记录')
        return
      }
      const body = this.buildTfRecordSubmitBody(
        disStart,
        disEnd,
        this.editRecordIsCreate ? '' : record_id,
        this.editRecordIsCreate
      )
      this.editRecordLoading = true
      const req = this.editRecordIsCreate ? addTfRecord(body) : editTfRecord(body)
      req
        .then(res => {
          if (res.status) {
            this.$message.success(res.msg || (this.editRecordIsCreate ? '添加成功' : '保存成功'))
            this.editRecordVisible = false
            this.getDetail()
          } else {
            this.$message.warning(res.msg || '保存失败')
          }
        })
        .finally(() => {
          this.editRecordLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-detail-page {
  padding: 16px 20px 30px;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.descriptionsBox {
  padding: 8px 0 0;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-head-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.status-tag {
  font-size: 13px;
  color: #26a4b2;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 12px;
  background: rgba(38, 164, 178, 0.1);
}
.month-count {
  font-size: 13px;
  color: #f56c6c;
  font-weight: 600;
}
.cert-imgs { display: flex; flex-wrap: wrap; gap: 10px; }
.cert-img { width: 90px; height: 90px; border-radius: 6px; border: 1px solid #ebeef5; }
.nurse-cell { line-height: 1.6; }
.nurse-name { font-weight: 600; color: #303133; }
.nurse-tel { color: #909399; font-size: 13px; }
.service-items-text { color: #606266; }
.empty-text { color: #c0c4cc; }
.refund-fee { color: #f56c6c; font-weight: 600; }
.delay-time { color: #f56c6c; font-weight: 600; }
.record-table {
  margin-top: 4px;
}
.w100 {
  width: 100%;
}
.service-items-block {
  text-align: left;
}
.service-item-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.service-item-line {
  font-size: 13px;
  color: #303133;
  line-height: 1.5;
  margin-bottom: 4px;
}
.service-item-imgs {
  margin-top: 2px;
}
.imgbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .litimg2 {
    width: 44px;
    height: 44px;
    margin: 4px 6px 4px 0;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    object-fit: cover;
    cursor: zoom-in;
  }
}
.visit-record-inline {
  font-size: 13px;
  color: #303133;
  line-height: 1.5;
  text-align: left;
}
.visit-media-block {
  margin-top: 8px;
  text-align: left;
}
.visit-media-label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
}
.visit-signature-block {
  margin-top: 10px;
}
.visit-assess-block {
  margin: 4px 0 8px;
  padding: 12px 12px 4px;
  background: #f9fafc;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.visit-assess-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}
.visit-nested-form-item {
  margin-bottom: 8px;
}
.visit-radio-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 2;
}
.visit-radio-stack .el-radio {
  margin-right: 0;
  margin-bottom: 6px;
  white-space: normal;
  line-height: 1.6;
}
.visit-inline-num {
  width: 72px;
  margin: 0 6px;
  vertical-align: middle;
}
.visit-radio-inline .el-radio {
  margin-right: 16px;
}
.visit-disease-name {
  margin-top: 10px;
  max-width: 100%;
}
.visit-scene-imgs {
  margin-top: 4px;
}
.visit-method-remark {
  margin-top: 10px;
  max-width: 100%;
}
.visit-safety-select {
  width: 100%;
  max-width: 280px;
}
</style>

<style lang="scss">
/* el-dialog 默认挂到 body，需非 scoped 才能命中 custom-class */
.service-record-edit-dialog {
  border-radius: 12px;
  overflow: hidden;
}
.service-record-edit-dialog .el-dialog__header {
  padding: 18px 20px 12px;
  font-weight: 600;
  font-size: 18px;
}
.service-record-edit-dialog .el-dialog__body {
  padding: 8px 20px 12px;
}
.service-record-edit-dialog .service-record-edit-body {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}
.service-record-edit-body .el-form-item {
  margin-bottom: 16px;
}
.service-content-hint {
  font-size: 12px;
  color: #909399;
  margin: 0 0 10px;
}
.edit-service-imgs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}
.edit-img-cell {
  position: relative;
  width: 56px;
  height: 56px;
}
.edit-img-thumb {
  width: 56px;
  height: 56px;
  border-radius: 6px;
  cursor: zoom-in;
}
.edit-img-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 14px;
  color: #909399;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
}
.edit-img-remove:hover {
  color: #f56c6c;
}
.edit-upload-placeholder {
  width: 56px;
  height: 56px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 20px;
  cursor: pointer;
  background: #fff;
}
.edit-upload-placeholder:hover {
  border-color: #26a4b2;
  color: #26a4b2;
}
.edit-record-footer .btn-cancel-outline {
  border-color: #26a4b2;
  color: #26a4b2;
  background: #fff;
}
.edit-record-footer .btn-cancel-outline:hover {
  background: #ecf8f9;
}
</style>
